import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NbIconModule, NbTooltipModule } from '@nebular/theme';
import { AiChatwootBuddyComponent } from './ai-chatwoot-buddy.component';
import { AiChatwootBuddyRoutingModule } from './ai-chatwoot-buddy-routing.module';
import { AttendanceComponent } from './attendance/attendance.component';

@NgModule({
  declarations: [AiChatwootBuddyComponent],
  imports: [
    CommonModule, 
    FormsModule, 
    NbIconModule, 
    AiChatwootBuddyRoutingModule,
    NbTooltipModule,
    AttendanceComponent
  ],
  exports: [AiChatwootBuddyComponent]
})
export class AiChatwootBuddyModule { }
